export const showOrHideField = (showOrHideInputs: string[], input: string) => {
  const show = showOrHideInputs.filter((inputName: any) => inputName === input);
  return show.length !== 1;
};
